<script lang="ts">
  import LinearGradientSvg from '../../components/SVGs/LinearGradientCircleSVG.svelte'

  let { label }: { label: string } = $props()
  const itemCount = 12
</script>

<div
  class="maskEffect absolute inset-x-0 bottom-0 hidden w-full overflow-hidden whitespace-nowrap sm-desktop:block"
>
  <ul class="relative flex w-max flex-wrap space-x-3 motion-safe:animate-stats-scroll">
    {#each Array(itemCount) as _, index (index)}
      <li class="relative z-[2] mb-6 flex items-center gap-x-3" aria-hidden={index >= itemCount / 2}>
        <LinearGradientSvg svgStyles="h-[18px] w-[18px]" />
        <p class="font-graphik text-[26px]">{label}</p>
      </li>
    {/each}
  </ul>
</div>

<style>
  .maskEffect {
    mask: linear-gradient(40deg, transparent 22%, white 40%, white 60%, transparent 80%);
  }
</style>
